// Pure conditional-required validation (NOTIF-07/09/10/13/14/15/16).
// Expresses every client-side 400-guard as data: validate(state, step) -> errors.
// Per-step Next gating is Object.keys(validate(state, step)).length === 0.
import { codepoints, parseUserIds } from "./text";

export const MAX_MESSAGE_LENGTH = 280;
export const MIN_PUSH_TITLE_LENGTH = 5;
export const MAX_USER_IDS = 2000;

// Steps mirror the 4-step stepper: 1 Audience, 2 Content, 3 Push, 4 Review & Send.
const AUDIENCE_STEP = 1;
const CONTENT_STEP = 2;
const PUSH_STEP = 3;
const REVIEW_STEP = 4;

// Absolute https: only (A11/OQ2) — relative paths and non-https schemes are rejected,
// any host is allowed (no allowlist).
const isAbsoluteHttpsUrl = (value) => {
  try {
    return new URL(value).protocol === "https:";
  } catch {
    return false;
  }
};

const validateAudience = (state) => {
  const errors = {};

  if (state.audience_type === "workspace" && (state.audience_roles || []).length === 0) {
    // The API would accept [] with 200 and resolve to 0 recipients — silent failure.
    errors.audience_roles = "Select at least one role";
  }

  if (state.audience_type === "user") {
    const ids = parseUserIds(state.user_ids);
    if (ids.length === 0) {
      errors.user_ids = "Enter at least one user id";
    } else if (ids.length > MAX_USER_IDS) {
      errors.user_ids = `Enter ${MAX_USER_IDS} user ids or fewer — you have ${ids.length}`;
    }
  }

  return errors;
};

const validateContent = (state) => {
  const errors = {};
  const messageLength = codepoints((state.message || "").trim());

  if (messageLength === 0) {
    errors.message = "Message is required";
  } else if (messageLength > MAX_MESSAGE_LENGTH) {
    errors.message = `Message must be ${MAX_MESSAGE_LENGTH} characters or fewer`;
  }

  const actionUrl = (state.action_url || "").trim();
  if (!actionUrl) {
    errors.action_url = "Link is required";
  } else if (!isAbsoluteHttpsUrl(actionUrl)) {
    errors.action_url = "Enter a full https:// URL";
  }

  if (!state.type) {
    errors.type = "Select a notification type";
  }

  if (!state.category) {
    errors.category = "Select a category";
  }

  return errors;
};

const validatePush = (state) => {
  const errors = {};

  if (
    state.send_push_notification &&
    codepoints((state.push_title || "").trim()) < MIN_PUSH_TITLE_LENGTH
  ) {
    errors.push_title = "Push title must be at least 5 characters";
  }

  return errors;
};

export const validate = (state, step) => {
  switch (step) {
    case AUDIENCE_STEP:
      return validateAudience(state);
    case CONTENT_STEP:
      return validateContent(state);
    case PUSH_STEP:
      return validatePush(state);
    case REVIEW_STEP:
      // Step 4 introduces no fields of its own — the Send gate is the full-form guard.
      return {
        ...validateAudience(state),
        ...validateContent(state),
        ...validatePush(state),
      };
    default:
      return {};
  }
};
